import {tokens, colors} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import {Text} from '@helios/shared/styles/typography'

import type {Location, LocationNames} from '../../shared'
import {getReplacePlaceholders} from '../../shared'

interface Props {
    budgetUsed: number
    location: Location
    budgetTotal: number
    progressBarText: string
    locationNames: LocationNames
}

export const ProgressBarWithText = ({
    budgetUsed,
    budgetTotal,
    location,
    progressBarText,
    locationNames,
}: Props) => {
    const replacePlaceholders = getReplacePlaceholders({
        location,
        budgetTotal,
        budgetUsed,
        locationNames,
    })

    const progress = (budgetUsed / budgetTotal) * 100

    return (
        <>
            <StyledProgressBar value={progress} max={100} aria-labelledby="progress-bar-text" />

            <StyledText variant="label-base" $progress={progress} id="progress-bar-text">
                {replacePlaceholders(progressBarText)}
            </StyledText>
        </>
    )
}

// Firefox takes styling for main component in main progress styles,
// and for the progress value in ::-moz-progress-bar
// This is different for webkit browsers, where background styles are in
// ::-webkit-progress-bar and progress value styles in ::-webkit-progress-value
const StyledProgressBar = styled.progress`
    width: 100%;
    height: ${tokens.spacing16};
    background-color: ${tokens.shade000};
    border: 1px solid ${colors.border.default};
    border-radius: ${tokens.arc8};
    appearance: none;

    ::-webkit-progress-bar {
        background-color: ${tokens.shade000};
        border-radius: ${tokens.arc8};
    }

    ::-moz-progress-bar {
        background-color: ${tokens.pink500};
        border-radius: ${tokens.arc8};
    }

    ::-webkit-progress-value {
        background-color: ${tokens.pink500};
        border-radius: ${tokens.arc8};
    }
`

interface StyledTextProps {
    $progress: number
}

const StyledText = styled(Text).attrs(({$progress}: StyledTextProps) => ({
    style: {
        width: `${$progress}%`,
    },
}))<StyledTextProps>`
    min-width: max-content;
    max-width: 100%;
    text-align: right;
`
